import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Layout
} from 'antd';

import styles from './AppFooter.module.css';

const { Footer } = Layout;
const { Text } = Typography;

const AppFooter = ({ copyright }) => (
  <Footer className={styles.footer}>
    <Text type="secondary">{copyright}</Text>
  </Footer>
);

AppFooter.propTypes = {
  copyright: PropTypes.string.isRequired,
};

export default AppFooter;
